module.exports = __webpack_public_path__ + "static/img/phone-cc.46016ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/phone-cc.png
// module id = rBCm
// module chunks = 1